import React, { useRef } from "react";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { arrowLeft } from "react-icons-kit/feather/arrowLeft";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import {
  EditMediaAPI,
  GetCategoryImage,
  GetMediaById,
  GetProductStatus,
  GetSubCategoryById,
  GetSubcategoriesProductsData,
  GetSubcategoryPage,
  api_url,
} from "../apiconfig/authService";
import { RiLoaderFill } from "react-icons/ri";
import { toast } from "react-toastify";

function EditMedia(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setMediaTableViewMessage = props.setMessage;

  const [mediaData, setMediaData] = useState({});
  const [editedMediaData, setEditedMediaData] = useState({});

  const { mediaid } = useParams();
  const [newImage, setNewImage] = useState(null);
  const [statusData, setStatusData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState(null);
  const [subCategoriesData, setSubCategoriesData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [subCategoryID, setSubCategoryID] = useState("");
  const [categoryID, setCategoryID] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [selectedItemName, setSelectedItemName] = useState("");
  const dropdownRef = useRef(null);
  const imageInputRef = React.createRef();
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
        setIsSearching(false);
        setSearchTerm("");
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Fixed filteredSubcategories logic
  const filteredSubcategories = Array.from(
    new Map(subCategoriesData.map((item) => [item.name, item])).values()
  ).filter((item) => {
    // If not searching or search term is empty, show all items
    if (!isSearching || !searchTerm || searchTerm.trim() === "") {
      return true;
    }
    // Filter by search term when actively searching
    return item.name.toLowerCase().includes(searchTerm.toLowerCase());
  });

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await GetMediaById(
          mediaid,
          localStorage.getItem("accessToken")
        );
        if (response?.data) {
          await getSubCategoryData(response?.data?._doc?.subcategoryid);
        }
        setLoading(false);
        setMediaData(response.data._doc);
        setEditedMediaData(response.data._doc);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const getSubCategoryData = async (subcategoryid) => {
    setLoading(true);
    try {
      const response = await GetSubCategoryById(
        subcategoryid,
        localStorage.getItem("accessToken")
      );
      setLoading(false);
      setSubCategoryData(response?.data?._doc);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        setLoading(false);
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const subcategoriesResponse = await GetSubcategoriesProductsData(
          localStorage.getItem("accessToken")
        );
        setLoading(false);
        setSubCategoriesData(
          subcategoriesResponse.data.subCategoriesItems || []
        );
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // Fixed handleSelectSubCategory function
  const handleSelectSubCategory = (item) => {
    setSubCategoryID(item.subcategoryid);
    setCategoryID(item.categoryid);
    setSelectedItemName(item.name);
    setSearchTerm(""); // clear search
    setSubCategoryData(item); // store selected
    setIsSearching(false); // exit search mode
    setIsDropdownOpen(false);
  };

  const handleTitleChange = (e) => {
    const temp = { ...editedMediaData };
    temp.title = e.target.value;
    setEditedMediaData(temp);
  };

  const handleUrlLinkChange = (e) => {
    const temp = { ...editedMediaData };
    temp.urlLink = e.target.value;
    setEditedMediaData(temp);
  };

  const handleImageChange = (e) => {
    setNewImage(e.target.files[0]);
  };

  const handleDiscardClick = async () => {
    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }
    setNewImage(null);
    const temp = { ...mediaData };
    setEditedMediaData(temp);
    navigate("/media");
  };

  const handleStatusChange = (e) => {
    const temp = { ...editedMediaData };
    temp.statusid = e.target.value;
    setEditedMediaData(temp);
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      if (editedMediaData.name === "") {
        toast.error("Media title is required!");
        return;
      }
      if (newImage) {
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
        if (!allowedTypes.includes(newImage.type)) {
          toast.error("Only JPG, JPEG, and PNG images are allowed!");
          return;
        }
      }
    } catch (error) {
      toast.error(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    const formData = new FormData();
    formData.append("title", editedMediaData.title);
    formData.append("urlLink", editedMediaData.urlLink);
    formData.append("mediaid", editedMediaData.mediaid);
    if (subCategoryID) {
      formData.append("subcategoryid", subCategoryID);
    }
    if (categoryID) {
      formData.append("categoryid", categoryID);
    }
    if (newImage) {
      formData.append("Image", newImage);
    }

    try {
      setEditLoading(true);
      response = await EditMediaAPI(
        formData,
        localStorage.getItem("accessToken")
      );
      if (response.status === 200) {
        setEditLoading(false);
        toast.success("Media Updated Successfully");
        setMediaTableViewMessage(response.data.message);
        navigate("/media");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setEditLoading(false);
        toast.error(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        toast.error("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    } finally {
      setEditLoading(false);
    }
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Media</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/media" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>

        {loading ? (
          <div className="d-flex align-items-center justify-content-center">
            <RiLoaderFill
              size={40}
              className="text-success spin-animation text-center"
            />
          </div>
        ) : (
          <div
            role="tabpanel"
            className="personal-info tab-pane active storetab"
            id="pi"
          >
            {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
            <div className="row">
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <label htmlFor="catName">Title</label>
                <input
                  type="text"
                  value={editedMediaData?.title || ""}
                  onChange={handleTitleChange}
                  className="form-control custom-input my-3"
                  id="catName"
                  placeholder="Media Title"
                />
              </div>
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <label htmlFor="catImg">Image</label>
                <input
                  type="file"
                  ref={imageInputRef}
                  className="form-control custom-input my-3"
                  id="catImg"
                  onChange={handleImageChange}
                  placeholder="Product Main Category Image"
                  accept="image/*"
                />
                <img
                  width="100px"
                  height="100px"
                  src={`${api_url}/product/category/getCategoryImage/${editedMediaData?.image}`}
                />
              </div>
            </div>

            <div className="row">
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <label htmlFor="catLink">URL Link</label>
                <input
                  type="text"
                  value={editedMediaData?.urlLink || ""}
                  className="form-control custom-input my-2"
                  id="catLink"
                  onChange={handleUrlLinkChange}
                  placeholder="URL Link"
                />
              </div>
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <label htmlFor="floatingInput">Status</label>
                <select
                  className="form-select custom-input my-2"
                  onChange={handleStatusChange}
                  value={editedMediaData?.statusid}
                >
                  {statusData?.map((item) => (
                    <option key={item.statusid} value={item.statusid}>
                      {item.status}
                    </option>
                  ))}
                </select>
              </div>

              {/* Fixed Screen Type dropdown section */}
              <div
                className="form-group col-sm-12 col-lg-6 mb-3"
                ref={dropdownRef}
              >
                <label>Screen Type</label>
                <div className="position-relative">
                  <input
                    type="text"
                    value={
                      isSearching
                        ? searchTerm
                        : subCategoryData?.name || selectedItemName
                    }
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setIsSearching(true);
                    }}
                    onClick={() => {
                      setIsDropdownOpen(true);
                      if (!isSearching) {
                        setIsSearching(true);
                        setSearchTerm("");
                      }
                    }}
                    placeholder={
                      isSearching
                        ? "Search screen type..."
                        : "Click to select screen type"
                    }
                    className="form-control custom-input my-2"
                  />

                  {isDropdownOpen && (
                    <div
                      className="border rounded bg-white position-absolute w-100 mt-1"
                      style={{
                        maxHeight: "200px",
                        overflowY: "auto",
                        zIndex: 999,
                      }}
                    >
                      {filteredSubcategories.length > 0 ? (
                        filteredSubcategories.map((item) => (
                          <div
                            key={item._id}
                            className="px-3 py-2 dropdown-item"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleSelectSubCategory(item)}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#f8f9fa";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "white";
                            }}
                          >
                            {item.name}
                          </div>
                        ))
                      ) : (
                        <div className="px-3 py-2 text-muted">
                          No results found
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className="col-12 d-flex"
                style={{ height: "40px", width: "120px" }}
              >
                <button
                  type="submit"
                  onClick={handleDiscardClick}
                  disabled={editLoading}
                  style={{ height: "100%", width: "100%" }}
                  className="btn btn-danger save-btn text-uppercase"
                >
                  Discard
                </button>{" "}
                &nbsp;
                {editLoading ? (
                  <div
                    className="btn btn-primary loader-active save-btn"
                    style={{ height: "100%", width: "100%" }}
                  >
                    <RiLoaderFill
                      size={20}
                      className="spin-animation"
                      color="white"
                    />
                  </div>
                ) : (
                  <button
                    type="submit"
                    onClick={handleSubmitClick}
                    disabled={editLoading}
                    className="btn btn-primary save-btn text-uppercase"
                    style={{ height: "100%", width: "100%" }}
                  >
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        <hr />
      </div>
    </div>
  );
}
export default EditMedia;
